import { default as QuestionsPage } from './QuestionsPage';
import { default as QuestionContainer } from './QuestionContainer';

export { QuestionContainer };
export default QuestionsPage;
